import amountFormat from "../../utils/amountFormat";
import Deposit from "../Account/components/Deposit";
import Withdraw from "../Account/components/Withdraw/Withdraw";
import TransactionsHistory from "../Account/components/TransactionHistory/TransactionsHistory";
import { useCallback, useEffect, useMemo } from "react";
import {
    CashierContentBalanceAmountStyled,
    CashierContentBalanceBoxStyled,
    CashierContentBalanceContainerStyled,
    CashierContentBalanceHeaderBadgeStyled,
    CashierContentBalanceHeaderStyled,
    CashierContentBalanceTitleStyled,
    CashierContentMenuStyled,
    CashierContentSideStyled,
    CashierContentTopStyled,
    CashierContentWrapperStyled,
    CashierWrapperStyled
} from "./styled/CashierStyled";
import { useDispatch, useSelector } from "react-redux";
import {
    makeSelectCurrentBalance,
    makeSelectCurrentEquity,
} from "../Account/accountSelectors";
import {
    accountGetPortfolioAction,
    depositCreateWebAction,
    getDepositSurveyStartAction
} from "../Account/accountActions";
import { isClientMobile } from "../../components/ClientInfo/ClientInfo";
import { Redirect, useLocation } from "react-router-dom";
import ToAppButton from "../../components/ToAppButton/ToAppButton";
import ProfileButton from "../Account/components/ProfileButton/ProfileButton";
import { MainHeader } from "../../components/main-header/MainHeader";
import { RouterPaths } from "../../app/appConstants";
import { useSetBodyBackgroundColor } from "../../components/UseSetBodyBackgroundColor/useSetBodyBackgroundHooks";
import { useGTMEvent } from "../GoogleTagManager/googleTagManagerHooks";
import { BonusTitle } from "../Bonus/components/BonusTitle.jsx";
import BonusActivePanel from "../Bonus/components/BonusActivePanel/BonusActivePanel";
import { useResponsive } from "../../components/responsive";
import { openModalAction } from "../../app/appActions.js";
import { getBonusActiveGift50 } from "../Bonus/bonusesSelectors";
import appHistory, { appHistoryReplaceWithSearchParams } from "../../app/appHistory";
import { MODALS_LOG_ACTION_TYPES } from "../Modals/Modals";
import { MODALS_NAME } from "../Modals/modalsConstants";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";
import CashierWithdrawalAmount from "./CashierWithdrawalAmount";
import { useCashierWithdrawalAmount } from "./cashierHooks";

const tabs = [
    {
        name: 'deposit',
        title: 'menu.deposit',
    },
    {
        name: 'withdraw',
        title: 'menu.withdraw',
    },
    {
        name: 'history',
        title: 'menu.transaction_history',
    },

];

export const CashierContent = (props) => {
    const { selectedItem } = props;
    const {getLangPath} = useLangContext();
    const {handleGTMClick, pushGtmEvent} = useGTMEvent({module: 'Cashier'});
    const {isMediumMaxWidth} = useResponsive();
    const location = useLocation();

    const dispatch = useDispatch();
    const activeBonusGift50 = useSelector(getBonusActiveGift50);
    const currentBalance = useSelector(makeSelectCurrentBalance());
    const currentEquity = useSelector(makeSelectCurrentEquity());

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const tab = searchParams.get('tab');
        if (!tab) {
            appHistoryReplaceWithSearchParams({tab: 'deposit'});
        }
    }, [location.search]);

    useEffect(() => {
        dispatch(accountGetPortfolioAction());
    }, [dispatch]);

    useEffect(() => {
        return () => {
            dispatch(getDepositSurveyStartAction({
                onShowDepositSurvey: () => dispatch(openModalAction(MODALS_NAME.DEPOSIT_SURVEY)),
            }));
        }
    }, [dispatch]);

    const setSelectedItem = useCallback((tab) => {
        dispatch(openModalAction({
            name: MODALS_NAME.CASHIER,
            action: MODALS_LOG_ACTION_TYPES.TAB,
            tab: tab,
        }));
    }, [dispatch]);

    const handleTabClick = useCallback((e) => {
        const tab = e.currentTarget.dataset.tab;
        setSelectedItem(tab);
        handleGTMClick({button: tab});
    }, [handleGTMClick, setSelectedItem]);

    const handleDepositNowClick = useCallback(() => {
        dispatch(openModalAction({
            name: MODALS_NAME.CASHIER,
            action: MODALS_LOG_ACTION_TYPES.TAB,
            tab: 'deposit',
        }));
        handleGTMClick({ button: 'deposit now' })
    }, [handleGTMClick, dispatch]);

    const withdrawalAmount = useCashierWithdrawalAmount();

    const handleBonusTitleClick = useCallback(() => {
        pushGtmEvent({event: 'bannerClick', banner: 'FirstDepositBonus'})
    }, [pushGtmEvent]);

    const handleVerifyButtonClick = useCallback(() => {
        appHistory.push(RouterPaths.verify);
        handleGTMClick({ button: 'verify' })
    }, [handleGTMClick]);

    const handleDepositCreate = useCallback((payload) => {
        dispatch(depositCreateWebAction(payload));
    }, [dispatch]);

    const payoutCreateCallback = useCallback(() => {
        dispatch(openModalAction(MODALS_NAME.WITHDRAWAL_REQUEST_SENT));
    }, [dispatch]);

    return (
            <>
                {
                        !activeBonusGift50 && selectedItem === 'deposit' && <div className="w-100">
                            <BonusTitle onClick={handleBonusTitleClick}/>
                        </div>
                }

                {
                        isMediumMaxWidth && <BonusActivePanel flat/>
                }

                <CashierContentWrapperStyled>
                    <CashierContentSideStyled className={'d-none d-md-block'}>
                        <div className="d-flex flex-column justify-content-between h-100">
                            <div>
                                <CashierContentBalanceBoxStyled>
                                    <CashierContentBalanceHeaderStyled>
                                        <CashierContentBalanceHeaderBadgeStyled>
                                            {getLangPath('menu.live')}
                                        </CashierContentBalanceHeaderBadgeStyled>
                                    </CashierContentBalanceHeaderStyled>
                                    {
                                            selectedItem !== 'withdraw' &&
                                            <CashierContentBalanceContainerStyled>
                                                <CashierContentBalanceTitleStyled className="mt-2">
                                                    {getLangPath('menu.balance')}
                                                </CashierContentBalanceTitleStyled>
                                                <CashierContentBalanceAmountStyled>
                                                    ${amountFormat(currentBalance)}
                                                </CashierContentBalanceAmountStyled>
                                                <CashierContentBalanceTitleStyled className="mt-2">
                                                    {getLangPath('menu.equity')}
                                                </CashierContentBalanceTitleStyled>
                                                <CashierContentBalanceAmountStyled className="text-color-secondary">
                                                    ${amountFormat(currentEquity)}
                                                </CashierContentBalanceAmountStyled>
                                            </CashierContentBalanceContainerStyled>
                                    }
                                    {
                                            selectedItem === 'withdraw' &&
                                            <CashierContentBalanceContainerStyled>
                                                <CashierContentBalanceTitleStyled className="mt-2">
                                                    {getLangPath('menu.withdrawal_funds')}
                                                </CashierContentBalanceTitleStyled>
                                                <CashierContentBalanceAmountStyled>
                                                    ${amountFormat(withdrawalAmount)}
                                                </CashierContentBalanceAmountStyled>
                                            </CashierContentBalanceContainerStyled>
                                    }
                                </CashierContentBalanceBoxStyled>

                                <CashierContentMenuStyled>
                                    {
                                        tabs.map(item => <div
                                                key={item.name}
                                                onClick={handleTabClick}
                                                data-tab={item.name}
                                                className={selectedItem === item.name ? 'active' : ''}>{getLangPath(item.title)}
                                        </div>)
                                    }
                                </CashierContentMenuStyled>
                            </div>
                            <BonusActivePanel/>
                        </div>

                    </CashierContentSideStyled>
                    <CashierContentTopStyled className={'d-md-none'}>
                        <div className="d-flex flex-column">
                            <div>
                                <CashierContentBalanceHeaderBadgeStyled>
                                    {getLangPath('menu.live')}
                                </CashierContentBalanceHeaderBadgeStyled>
                            </div>
                            <div className="d-flex">
                                {
                                        selectedItem !== 'withdraw' &&
                                        <>
                                            <div className="flex-grow-1">
                                                <CashierContentBalanceTitleStyled className="mt-2">
                                                    {getLangPath('menu.balance')}
                                                </CashierContentBalanceTitleStyled>
                                                <CashierContentBalanceAmountStyled>
                                                    ${amountFormat(currentBalance)}
                                                </CashierContentBalanceAmountStyled>
                                            </div>
                                            <div className="flex-grow-1">
                                                <CashierContentBalanceTitleStyled className="mt-2">
                                                    {getLangPath('menu.equity')}
                                                </CashierContentBalanceTitleStyled>
                                                 <CashierContentBalanceAmountStyled className="text-color-secondary">
                                                    ${amountFormat(currentEquity)}
                                                </CashierContentBalanceAmountStyled>
                                            </div>
                                        </>
                                }
                                {
                                        selectedItem === 'withdraw' &&
                                        <div>
                                            <CashierWithdrawalAmount amount={withdrawalAmount}/>
                                        </div>
                                }
                            </div>
                        </div>
                    </CashierContentTopStyled>
                    <CashierContentMenuStyled className={'d-md-none'}>
                        {
                            tabs.map(item => <div
                                    key={item.name}
                                    onClick={handleTabClick}
                                    data-tab={item.name}
                                    className={selectedItem === item.name ? 'active' : ''}>{getLangPath(item.title)}
                            </div>)
                        }
                    </CashierContentMenuStyled>
                    {selectedItem === 'deposit' && <Deposit
                        depositCreate={handleDepositCreate}
                    />}
                    {selectedItem === 'withdraw' && <Withdraw
                            onDepositNowButtonClick={handleDepositNowClick}
                            onVerifyButtonClick={handleVerifyButtonClick}
                            payoutCreateCallback={payoutCreateCallback}
                            withdrawalAmount={withdrawalAmount}/>}
                    {selectedItem === 'history' && <TransactionsHistory setSelectedItem={setSelectedItem}/>}
                </CashierContentWrapperStyled>
            </>
    )
}

export const Cashier = () => {
    useSetBodyBackgroundColor('var(--app-bg-modal-color)', true);
    const {getLangPath} = useLangContext();
    const location = useLocation();

    const selectedItem = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams.get('tab');
    }, [location]);

    if (!isClientMobile) {
        const urlParams = new URLSearchParams(location.search);
        urlParams.set('m', 'cashier');
        return <Redirect to={{
            pathname: RouterPaths.trade,
            search: urlParams.toString(),
        }}/>
    }
    return (
            <CashierWrapperStyled>
                <MainHeader background={"var(--color-surface-secondary)"} fixed>
                    <ToAppButton label={getLangPath('menu.trade')}/>
                    <ProfileButton className="ms-2 ms-sm-3"/>
                </MainHeader>
                <CashierContent selectedItem={selectedItem}/>
            </CashierWrapperStyled>
    )
}
